<template>
  <v-row justify="center" align="center" style="height: 100%">
    <v-col cols="12" sm="6" md="5">
    <div class="card">
      <BlockSettings :hideButtons="true" />
    </div>
      </v-col>
  </v-row>
</template>

<script>
import BlockSettings from "../components/BlockSettings.vue";
import Navbar from "@/components/Navbar";
import {
  collection,
  getDocs,
  getFirestore,
  where,
  setDoc,
  doc,
  query,
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);
import { debounce } from "../helpers.js";
export default {
  components: { Navbar, BlockSettings },
  data() {
    return {
      suspendingUser: true,
    };
  },
};
</script>

<style scoped>
.card {
  box-shadow: 4px 4px 32px grey;
  width: 100%;
  border-radius: 20px;
}
</style>
